import styled, { keyframes } from 'styled-components';

// Animações
const glowPulse = keyframes`
  0% { box-shadow: 0 0 10px rgba(64, 128, 255, 0.4); }
  50% { box-shadow: 0 0 20px rgba(0, 255, 255, 0.7), 0 0 30px rgba(64, 128, 255, 0.5); }
  100% { box-shadow: 0 0 10px rgba(64, 128, 255, 0.4); }
`;

const glowPulseIntense = keyframes`
  0% { box-shadow: 0 0 15px rgba(64, 128, 255, 0.5), 0 0 5px rgba(0, 255, 255, 0.3) inset; }
  10% { box-shadow: 0 0 16px rgba(64, 128, 255, 0.52), 0 0 6px rgba(0, 255, 255, 0.32) inset; }
  20% { box-shadow: 0 0 18px rgba(0, 255, 255, 0.55), 0 0 20px rgba(64, 128, 255, 0.45), 0 0 6px rgba(0, 255, 255, 0.35) inset; }
  25% { box-shadow: 0 0 20px rgba(0, 255, 255, 0.6), 0 0 25px rgba(64, 128, 255, 0.5), 0 0 7px rgba(0, 255, 255, 0.4) inset; }
  40% { box-shadow: 0 0 25px rgba(0, 255, 255, 0.7), 0 0 35px rgba(64, 128, 255, 0.55), 0 0 9px rgba(0, 255, 255, 0.45) inset; }
  50% { box-shadow: 0 0 30px rgba(0, 255, 255, 0.8), 0 0 40px rgba(64, 128, 255, 0.6), 0 0 10px rgba(0, 255, 255, 0.5) inset; }
  60% { box-shadow: 0 0 25px rgba(0, 255, 255, 0.7), 0 0 35px rgba(64, 128, 255, 0.55), 0 0 9px rgba(0, 255, 255, 0.45) inset; }
  75% { box-shadow: 0 0 20px rgba(0, 255, 255, 0.6), 0 0 25px rgba(64, 128, 255, 0.5), 0 0 7px rgba(0, 255, 255, 0.4) inset; }
  80% { box-shadow: 0 0 18px rgba(0, 255, 255, 0.55), 0 0 20px rgba(64, 128, 255, 0.45), 0 0 6px rgba(0, 255, 255, 0.35) inset; }
  85% { box-shadow: 0 0 17px rgba(64, 128, 255, 0.53), 0 0 15px rgba(0, 255, 255, 0.43), 0 0 5.5px rgba(0, 255, 255, 0.33) inset; }
  90% { box-shadow: 0 0 16px rgba(64, 128, 255, 0.52), 0 0 10px rgba(0, 255, 255, 0.32), 0 0 5px rgba(0, 255, 255, 0.32) inset; }
  95% { box-shadow: 0 0 15.5px rgba(64, 128, 255, 0.51), 0 0 7px rgba(0, 255, 255, 0.31), 0 0 5px rgba(0, 255, 255, 0.31) inset; }
  100% { box-shadow: 0 0 15px rgba(64, 128, 255, 0.5), 0 0 5px rgba(0, 255, 255, 0.3) inset; }
`;

const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const techCirclePulse = keyframes`
  0% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.1); opacity: 0.7; }
  100% { transform: scale(1); opacity: 0.3; }
`;

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const dataFlow = keyframes`
  0% { transform: translateY(0); opacity: 0; }
  20% { opacity: 0.8; }
  80% { opacity: 0.8; }
  100% { transform: translateY(-20px); opacity: 0; }
`;

const iconPulse = keyframes`
  0% { transform: scale(1); filter: drop-shadow(0 0 3px rgba(0, 255, 255, 0.5)); }
  50% { transform: scale(1.15); filter: drop-shadow(0 0 8px rgba(0, 255, 255, 0.8)); }
  100% { transform: scale(1); filter: drop-shadow(0 0 3px rgba(0, 255, 255, 0.5)); }
`;

const borderFlash = keyframes`
  0% { border-color: rgba(64, 128, 255, 0.6); }
  10% { border-color: rgba(64, 128, 255, 0.63); }
  15% { border-color: rgba(64, 128, 255, 0.65); }
  20% { border-color: rgba(0, 255, 255, 0.68); }
  25% { border-color: rgba(0, 255, 255, 0.7); }
  30% { border-color: rgba(0, 255, 255, 0.75); }
  35% { border-color: rgba(0, 255, 255, 0.8); }
  40% { border-color: rgba(0, 255, 255, 0.85); }
  50% { border-color: rgba(0, 255, 255, 0.9); }
  60% { border-color: rgba(0, 255, 255, 0.85); }
  65% { border-color: rgba(0, 255, 255, 0.8); }
  70% { border-color: rgba(0, 255, 255, 0.75); }
  75% { border-color: rgba(0, 255, 255, 0.7); }
  80% { border-color: rgba(0, 255, 255, 0.68); }
  85% { border-color: rgba(64, 128, 255, 0.65); }
  90% { border-color: rgba(64, 128, 255, 0.63); }
  95% { border-color: rgba(64, 128, 255, 0.61); }
  100% { border-color: rgba(64, 128, 255, 0.6); }
`;

const scanLine = keyframes`
  0% { transform: translateY(-100%); opacity: 0.5; }
  100% { transform: translateY(100%); opacity: 0; }
`;

const arrowMove = keyframes`
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(-3px); }
`;

// Container para os botões
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  margin: 3.5rem auto;
  position: relative;
  z-index: 5;
  max-width: 600px;
  width: 100%;
  
  @media (max-width: 768px) {
    gap: 1.8rem;
    max-width: 90%;
  }
  
  /* Linhas tecnológicas */
  &::before {
    content: '';
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    width: 250px;
    height: 2px;
    background: linear-gradient(to right, rgba(64, 128, 255, 0), rgba(64, 128, 255, 0.7), rgba(64, 128, 255, 0));
    filter: drop-shadow(0 0 5px rgba(64, 128, 255, 0.5));
    animation: ${glowPulse} 3s infinite;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    width: 250px;
    height: 2px;
    background: linear-gradient(to right, rgba(64, 128, 255, 0), rgba(64, 128, 255, 0.7), rgba(64, 128, 255, 0));
    filter: drop-shadow(0 0 5px rgba(64, 128, 255, 0.5));
    animation: ${glowPulse} 3s infinite 1.5s;
  }
`;

// Botão tecnológico base
export const TechButton = styled.button`
  position: relative;
  padding: 0.9rem 1.8rem;
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: white;
  background: linear-gradient(135deg, rgba(16, 32, 64, 0.8), rgba(32, 64, 128, 0.8));
  border: 1px solid rgba(64, 128, 255, 0.5);
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: ${glowPulse} 3s infinite ease-in-out;
  z-index: 1;
  width: 100%;
  max-width: 320px;
  
  /* Círculos tecnológicos */
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle at center,
      rgba(64, 128, 255, 0.1) 0%,
      rgba(0, 255, 255, 0.05) 30%,
      transparent 70%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
  }
  
  /* Linhas de grade */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(90deg, rgba(64, 128, 255, 0.1) 1px, transparent 1px),
      linear-gradient(0deg, rgba(64, 128, 255, 0.1) 1px, transparent 1px);
    background-size: 10px 10px;
    z-index: -1;
  }
  
  /* Efeito de brilho na borda */
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 0 15px rgba(64, 128, 255, 0.6),
      0 0 30px rgba(0, 255, 255, 0.3);
    border-color: rgba(0, 255, 255, 0.8);
    
    &::before {
      opacity: 1;
    }
  }
  
  /* Efeito de clique */
  &:active {
    transform: translateY(1px);
    box-shadow: 0 0 10px rgba(64, 128, 255, 0.4);
  }
`;

// Botão de voltar
export const BackButton = styled(TechButton)`
  background: linear-gradient(135deg, rgba(32, 64, 96, 0.8), rgba(16, 32, 64, 0.8));
  border-color: rgba(64, 128, 255, 0.4);
  font-size: 0.9rem;
  padding: 0.8rem 1.6rem;
  opacity: 0.85;
  border-radius: 30px;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .arrow-icon {
    margin-right: 4px;
    animation: ${arrowMove} 2s infinite ease-in-out;
    filter: drop-shadow(0 0 3px rgba(64, 128, 255, 0.5));
  }
  
  &:hover {
    opacity: 1;
    transform: translateY(-2px);
    box-shadow: 
      0 0 10px rgba(64, 128, 255, 0.4),
      0 0 20px rgba(0, 255, 255, 0.2);
      
    .arrow-icon {
      animation: ${arrowMove} 1s infinite ease-in-out;
    }
  }
`;

// Botão de agendamento
export const ScheduleButton = styled(TechButton)`
  background: linear-gradient(135deg, #4080ff, #34cfeb);
  background-size: 200% 200%;
  will-change: transform, box-shadow, border-color;
  animation: 
    ${gradientMove} 5s ease infinite, 
    ${glowPulseIntense} 8s infinite cubic-bezier(0.4, 0.0, 0.2, 1), 
    ${borderFlash} 8s infinite cubic-bezier(0.4, 0.0, 0.2, 1);
  border-color: rgba(0, 255, 255, 0.6);
  border-width: 2px;
  font-size: 1.1rem;
  padding: 1rem 2.2rem;
  transform: scale(1.1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 30px;
  min-width: 280px;
  letter-spacing: 1.5px;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  position: relative;
  overflow: hidden;
  margin-top: 0.5rem;
  filter: drop-shadow(0 0 10px rgba(0, 255, 255, 0.3));
  
  /* Efeito de escaneamento */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(0, 255, 255, 0.1) 50%,
      transparent 100%
    );
    animation: ${scanLine} 2s linear infinite;
    z-index: 0;
  }
  
  /* Ícone de calendário */
  .calendar-icon {
    animation: ${iconPulse} 2s infinite ease-in-out;
    margin-right: 2px;
    filter: drop-shadow(0 0 5px rgba(0, 255, 255, 0.6));
    position: relative;
    z-index: 1;
  }
  
  /* Círculos tecnológicos pulsantes */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px dashed rgba(0, 255, 255, 0.5);
    transform: translate(-50%, -50%);
    animation: ${techCirclePulse} 3s infinite, ${rotate} 10s linear infinite;
    z-index: -1;
  }
  
  /* Partículas de dados */
  .data-particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(0, 255, 255, 0.8);
    border-radius: 50%;
    pointer-events: none;
    z-index: -1;
    animation: ${dataFlow} 2s infinite;
  }
  
  &:hover {
    transform: scale(1.15) translateY(-3px);
    box-shadow: 
      0 0 20px rgba(64, 128, 255, 0.7),
      0 0 40px rgba(0, 255, 255, 0.4),
      0 0 10px rgba(0, 255, 255, 0.3) inset;
    letter-spacing: 2px;
  }
`;

// Estilos para o modal (serão usados no próximo comando)
export const ModalOverlayStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 25, 47, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  
  /* Efeito de grade digital no fundo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(rgba(64, 128, 255, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(64, 128, 255, 0.05) 1px, transparent 1px);
    background-size: 20px 20px;
    opacity: 0.3;
    pointer-events: none;
  }
`;
